export default __webpack_public_path__ + "static/media/color.506bfb79.png";